import { useState } from 'react';
import { useParams } from 'react-router-dom';
import CreateFormTopBar from '../../../../../Components/TopBar/CreateFormTopBar';
import { TOPBAR_CONFIGS } from '../../../../../Components/TopBar/topBarConfigs';
import ChecklistService from '../../../../../AppSettings/services/ChecklistService';
import { isLegalEnvironment } from '../../../../../AppSettings/environmentConfig';

import './CreateMatterChecklistPage.css';
import FormEntryMultilineTextbox from '@frontend/Components/Forms/Entry/MultilineTextbox/FormEntryMultilineTextbox';

const CreateMatterChecklistPage = () => {
  const { matterId } = useParams();

  const [formData, setFormData] = useState({
    checklistid: '', // Optional if auto-generated
    description: '',
    status: 'Pending', // Default value
    matterid: matterId,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleChecklistCreation = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await ChecklistService.addChecklistItem(
        formData
      );
      if (response.error) throw new Error(response.error);
      alert('Checklist item added successfully!');
      setFormData({
        checklistid: '',
        description: '',
        status: 'Pending',
        matterid: matterId,
      });
    } catch (error) {
      console.error('Error adding checklist item:', error);
      setError('Failed to add the checklist item. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="Tasks-Page">
      {/* Pass the handleChecklistCreation function to CreateFormTopBar */}
      <CreateFormTopBar
        config={isLegalEnvironment ? TOPBAR_CONFIGS.MATTER_CHECKLIST : TOPBAR_CONFIGS.PROJECT_CHECKLIST}
        onSave={handleChecklistCreation}
        pageContext={{ matterId }}
      />
      <div
        className="Tasks-entire-form-container"
        style={{ justifyContent: 'center' }}
      >
        <div className="Tasks-form-container">
          <div className="Tasks-form-group">
            <label className="Tasks-form-group-label">Description</label>
            <FormEntryMultilineTextbox
              name="description"
              placeholder="Enter checklist description"
              value={formData.description}
              onChange={handleInputChange}
            />
          </div>

          <div className="Tasks-form-group">
            <label className="Tasks-form-group-label">Status</label>
            <div className="Tasks-input-icon">
              <select
                name="status"
                value={formData.status}
                onChange={handleInputChange}
              >
                <option value="Pending">Pending</option>
                <option value="Completed">Completed</option>
              </select>
            </div>
          </div>

          {error && <div className="error-message">{error}</div>}
          {loading && (
            <div className="loading-message">Adding checklist item...</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateMatterChecklistPage;
